import { useState, useEffect } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function LeadForm({ source = "contact_form", compact = false }) {
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "", course: "", city: "", message: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/courses").then(({ data }) => setCourses(data)).catch(() => {});
  }, []);

  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Name and phone are required");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source });
      toast.success("Thanks! We'll get back to you shortly.");
      setForm({ name: "", email: "", phone: "", course: "", city: "", message: "" });
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const cls = "w-full px-4 py-3 rounded-xl border border-neutral-200 bg-white text-sm focus:outline-none focus:border-sky-500 transition-colors";

  return (
    <form onSubmit={submit} className={`grid ${compact ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"} gap-4`} data-testid="lead-form">
      <input required placeholder="Your name*" value={form.name} onChange={change("name")} className={cls} data-testid="lead-name" />
      <input required placeholder="Phone number*" value={form.phone} onChange={change("phone")} className={cls} data-testid="lead-phone" />
      <input type="email" placeholder="Email address" value={form.email} onChange={change("email")} className={cls} data-testid="lead-email" />
      <input placeholder="City" value={form.city} onChange={change("city")} className={cls} data-testid="lead-city" />
      <select value={form.course} onChange={change("course")} className={`${cls} ${compact ? "" : "md:col-span-2"}`} data-testid="lead-course">
        <option value="">Select a course (optional)</option>
        {courses.map((c) => <option key={c.id} value={c.title}>{c.title}</option>)}
      </select>
      <textarea rows={compact ? 3 : 4} placeholder="Your message" value={form.message} onChange={change("message")} className={`${cls} ${compact ? "" : "md:col-span-2"}`} data-testid="lead-message" />
      <button type="submit" disabled={loading} className={`btn-primary-eq justify-center ${compact ? "" : "md:col-span-2"}`} data-testid="lead-submit">
        {loading ? "Sending..." : "Request a Callback"}
      </button>
    </form>
  );
}
